// extracted by mini-css-extract-plugin
module.exports = {"container":"MapResult_container__3zNL-","progress":"MapResult_progress__IddvB","nav":"MapResult_nav__4T5eL","back":"MapResult_back__2QbB3","result":"MapResult_result__1cYEG"};